import api, { withLoading } from '@/api/api';

const resource = `v1/ict/projetos`;
const LOADING_KEY = 'ict-projetos';

export default {
    selecao(empresaId) {
        return withLoading(LOADING_KEY, () =>
            api.get(`${resource}/${empresaId}/selecao`).then(res => res.data)
        );
    },
    getAll(empresaId, params = {}) {
        const { query } = params;
        return api.get(`${resource}/${empresaId}${query ? `?${query}` : ""}`).then(res => res.data);
    },
    getOne(empresaId, projetoId) {
        return api.get(`${resource}/${empresaId}/${projetoId}`).then(res => res.data);
    },
    create(empresaId, data) {
        return api.post(`${resource}/${empresaId}`, data).then(res => res.data);
    },
    update(empresaId, projetoId, data) {
        return api.post(`${resource}/${empresaId}/${projetoId}`, data).then(res => res.data);
    },
    clone(empresaId, projetoId, data) {
        return api.post(`${resource}/${empresaId}/${projetoId}/clonar`, data).then(res => res.data);
    },
    delete(empresaId, projetoId) {
        return api.delete(`${resource}/${empresaId}/${projetoId}`).then(res => res.data);
    },
    downloadAll(empresaId, projetoId) {
        return api.get(`${resource}/${empresaId}/${projetoId}/download-all`, { responseType: 'blob' })
            .then(res => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `anexos_projeto_${projetoId}.zip`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            });
    }
}
